(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[7533,9489],{

/***/ 27532:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "B": function() { return /* binding */ ButtonHierarchy; },
/* harmony export */   "z": function() { return /* binding */ Button; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(14251);
/* harmony import */ var _swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(52875);
/* harmony import */ var _swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(44747);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var next_dynamic__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(5152);
/* harmony import */ var next_dynamic__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(next_dynamic__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(67294);
/* harmony import */ var _button_module_scss__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(11069);
/* harmony import */ var _button_module_scss__WEBPACK_IMPORTED_MODULE_5___default = /*#__PURE__*/__webpack_require__.n(_button_module_scss__WEBPACK_IMPORTED_MODULE_5__);
/* harmony import */ var _types_system__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(16693);








var Icon = next_dynamic__WEBPACK_IMPORTED_MODULE_1___default()(function() {
    return Promise.all(/* import() */[__webpack_require__.e(8075), __webpack_require__.e(9878), __webpack_require__.e(6244)]).then(__webpack_require__.bind(__webpack_require__, 56244));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(56244)
            ];
        }
    }
});
var ButtonHierarchy;
(function(ButtonHierarchy) {
    ButtonHierarchy["Bezeled"] = "bezeled";
    ButtonHierarchy["BezeledGray"] = "bezeled-gray";
    ButtonHierarchy["Borderless"] = "borderless";
    ButtonHierarchy["BorderlessGray"] = "borderless-gray";
    ButtonHierarchy["ChipChoice"] = "chip-choice";
    ButtonHierarchy["ChipFilter"] = "chip-filter";
    ButtonHierarchy["Filled"] = "filled";
    ButtonHierarchy["Outline"] = "outline";
    ButtonHierarchy["Success"] = "success";
    ButtonHierarchy["TabChoice"] = "tab-choice";
    ButtonHierarchy["Text"] = "text";
    ButtonHierarchy["Black"] = "black";
})(ButtonHierarchy || (ButtonHierarchy = {}));
var Button = function(_param) {
    var hierarchy = _param.hierarchy, _disabled = _param.disabled, disabled = _disabled === void 0 ? false : _disabled, label = _param.label, size = _param.size, _icon = _param.icon, icon = _icon === void 0 ? "" : _icon, _iconPosition = _param.iconPosition, iconPosition = _iconPosition === void 0 ? "left" : _iconPosition, _leadingIcon = _param.leadingIcon, leadingIcon = _leadingIcon === void 0 ? "" : _leadingIcon, _trailingIcon = _param.trailingIcon, trailingIcon = _trailingIcon === void 0 ? "" : _trailingIcon, _isSelected = _param.isSelected, isSelected = _isSelected === void 0 ? false : _isSelected, _hasBackground = _param.hasBackground, hasBackground = _hasBackground === void 0 ? true : _hasBackground, _hasPadding = _param.hasPadding, hasPadding = _hasPadding === void 0 ? true : _hasPadding, _hasTransition = _param.hasTransition, hasTransition = _hasTransition === void 0 ? true : _hasTransition, _hasUnderline = _param.hasUnderline, hasUnderline = _hasUnderline === void 0 ? false : _hasUnderline, _theme = _param.theme, theme = _theme === void 0 ? _types_system__WEBPACK_IMPORTED_MODULE_3__/* .Theme.light */ .Q2.light : _theme, ariaLabel = _param.ariaLabel, _isSquare = _param.isSquare, isSquare = _isSquare === void 0 ? false : _isSquare, _isLoading = _param.isLoading, isLoading = _isLoading === void 0 ? false : _isLoading, _hasIcon = _param.hasIcon, hasIcon = _hasIcon === void 0 ? false : _hasIcon, _className = _param.className, className = _className === void 0 ? "" : _className, _type = _param.type, type = _type === void 0 ? "button" : _type, children = _param.children, _loader = _param.loader, loader = _loader === void 0 ? "default" : _loader, _retainWidthOnLoadingState = _param.retainWidthOnLoadingState, retainWidthOnLoadingState = _retainWidthOnLoadingState === void 0 ? false : _retainWidthOnLoadingState, restProps = (0,_swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)(_param, [
        "hierarchy",
        "disabled",
        "label",
        "size",
        "icon",
        "iconPosition",
        "leadingIcon",
        "trailingIcon",
        "isSelected",
        "hasBackground",
        "hasPadding",
        "hasTransition",
        "hasUnderline",
        "theme",
        "ariaLabel",
        "isSquare",
        "isLoading",
        "hasIcon",
        "className",
        "type",
        "children",
        "loader",
        "retainWidthOnLoadingState"
    ]);
    var commonProps = {
        className: "".concat((_button_module_scss__WEBPACK_IMPORTED_MODULE_5___default().main), " ").concat(className),
        "data-is-square": icon && !label || isSquare.toString(),
        "data-hierarchy": hierarchy,
        "data-selected": isSelected,
        "data-size": size,
        "data-has-transition": isLoading ? false : hasTransition,
        "data-has-icon": hasIcon || !!icon || !!leadingIcon || !!trailingIcon,
        "data-icon-position": iconPosition,
        "data-has-background": hasBackground,
        "data-has-padding": hasPadding,
        "data-theme": theme,
        "aria-label": ariaLabel ? ariaLabel : icon ? icon : label,
        "data-has-underline": hasUnderline,
        "data-is-loading": isLoading,
        "data-retains-width-on-load": retainWidthOnLoadingState,
        disabled: disabled
    };
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("button", (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z)({}, restProps, commonProps), {
        onClick: function(e) {
            if (isLoading) {
                return;
            }
            if (restProps.onClick) {
                restProps.onClick(e);
            }
        },
        type: type,
        children: [
            leadingIcon && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(Icon, {
                name: leadingIcon,
                size: size === _types_system__WEBPACK_IMPORTED_MODULE_3__/* .Size.Large */ .$u.Large ? _types_system__WEBPACK_IMPORTED_MODULE_3__/* .Size.Large */ .$u.Large : _types_system__WEBPACK_IMPORTED_MODULE_3__/* .Size.Medium */ .$u.Medium
            }),
            iconPosition === "right" && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                className: (_button_module_scss__WEBPACK_IMPORTED_MODULE_5___default().label),
                children: label
            }),
            icon && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(Icon, {
                name: icon,
                size: size === _types_system__WEBPACK_IMPORTED_MODULE_3__/* .Size.Large */ .$u.Large ? _types_system__WEBPACK_IMPORTED_MODULE_3__/* .Size.Large */ .$u.Large : _types_system__WEBPACK_IMPORTED_MODULE_3__/* .Size.Medium */ .$u.Medium
            }),
            iconPosition === "left" && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                className: (_button_module_scss__WEBPACK_IMPORTED_MODULE_5___default().label),
                children: label
            }),
            isLoading && (loader === "dots" ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                className: (_button_module_scss__WEBPACK_IMPORTED_MODULE_5___default()["loader-container"]),
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                    className: (_button_module_scss__WEBPACK_IMPORTED_MODULE_5___default()["loader-dots"])
                })
            }) : /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(Icon, {
                customClass: (_button_module_scss__WEBPACK_IMPORTED_MODULE_5___default().loader),
                name: "Loader2",
                size: size === _types_system__WEBPACK_IMPORTED_MODULE_3__/* .Size.Large */ .$u.Large ? _types_system__WEBPACK_IMPORTED_MODULE_3__/* .Size.Large */ .$u.Large : _types_system__WEBPACK_IMPORTED_MODULE_3__/* .Size.Medium */ .$u.Medium
            })),
            trailingIcon && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(Icon, {
                name: trailingIcon,
                size: size === _types_system__WEBPACK_IMPORTED_MODULE_3__/* .Size.Large */ .$u.Large ? _types_system__WEBPACK_IMPORTED_MODULE_3__/* .Size.Large */ .$u.Large : _types_system__WEBPACK_IMPORTED_MODULE_3__/* .Size.Medium */ .$u.Medium
            }),
            children
        ]
    }));
};


/***/ }),

/***/ 96732:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "B": function() { return /* reexport safe */ _Button__WEBPACK_IMPORTED_MODULE_0__.B; },
/* harmony export */   "z": function() { return /* reexport safe */ _Button__WEBPACK_IMPORTED_MODULE_0__.z; }
/* harmony export */ });
/* harmony import */ var _Button__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(27532);



/***/ }),

/***/ 82032:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "OneTapVariant": function() { return /* reexport */ OneTapVariant; },
  "default": function() { return /* reexport */ OneTap; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/@ebay/nice-modal-react/lib/esm/index.js
var esm = __webpack_require__(25362);
// EXTERNAL MODULE: ./node_modules/@aws-amplify/auth/dist/esm/providers/cognito/apis/signInWithRedirect.mjs + 17 modules
var signInWithRedirect = __webpack_require__(79161);
// EXTERNAL MODULE: ./node_modules/next/dynamic.js
var dynamic = __webpack_require__(5152);
var dynamic_default = /*#__PURE__*/__webpack_require__.n(dynamic);
// EXTERNAL MODULE: ./node_modules/next/image.js
var next_image = __webpack_require__(25675);
var image_default = /*#__PURE__*/__webpack_require__.n(next_image);
// EXTERNAL MODULE: ./node_modules/next/router.js
var next_router = __webpack_require__(11163);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/react-redux/es/index.js + 20 modules
var es = __webpack_require__(14416);
// EXTERNAL MODULE: ./components/styleguide/Button/index.ts
var Button = __webpack_require__(96732);
// EXTERNAL MODULE: ./components/styleguide/OneTap/one-tap.module.scss
var one_tap_module = __webpack_require__(29688);
var one_tap_module_default = /*#__PURE__*/__webpack_require__.n(one_tap_module);
// EXTERNAL MODULE: ./lib/constants.js + 1 modules
var constants = __webpack_require__(99280);
// EXTERNAL MODULE: ./lib/hooks/useAdminMode.ts
var useAdminMode = __webpack_require__(67964);
// EXTERNAL MODULE: ./store/selectors/system.js
var system = __webpack_require__(17338);
;// CONCATENATED MODULE: ./lib/hooks/useCookiebot.ts




var useCookieBot = function() {
    var router = (0,next_router.useRouter)();
    var hasLoaded = (0,es/* useSelector */.v9)(system/* selectHasCookieBotLoaded */.hL);
    var ref = (0,react.useState)(false), isVisible = ref[0], setIsVisible = ref[1];
    (0,react.useEffect)(function() {
        if (hasLoaded && router.asPath) {
            var showTimer = setTimeout(function() {
                if (typeof window.Cookiebot !== "undefined") {
                    setIsVisible(!window.Cookiebot.hasResponse);
                }
            }, 100);
            return function() {
                clearTimeout(showTimer);
            };
        }
    }, [
        hasLoaded,
        router.asPath
    ]);
    return {
        isVisible: isVisible
    };
};

// EXTERNAL MODULE: ./lib/routes.js
var routes = __webpack_require__(7158);
// EXTERNAL MODULE: ./lib/utilities/system.js + 1 modules
var utilities_system = __webpack_require__(70591);
// EXTERNAL MODULE: ./lib/utilities/vehicle.js
var vehicle = __webpack_require__(13732);
// EXTERNAL MODULE: ./store/actions/event.js
var actions_event = __webpack_require__(61748);
// EXTERNAL MODULE: ./store/reducers/user.js
var user = __webpack_require__(64727);
// EXTERNAL MODULE: ./store/selectors/user.js
var selectors_user = __webpack_require__(15433);
// EXTERNAL MODULE: ./types/system.ts
var types_system = __webpack_require__(16693);
;// CONCATENATED MODULE: ./components/styleguide/OneTap/OneTap.tsx




















var Icon = dynamic_default()(function() {
    return Promise.all(/* import() */[__webpack_require__.e(8075), __webpack_require__.e(9878), __webpack_require__.e(6244)]).then(__webpack_require__.bind(__webpack_require__, 56244));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(56244)
            ];
        }
    }
});
var AuthenticationModal = dynamic_default()(function() {
    return Promise.all(/* import() */[__webpack_require__.e(1852), __webpack_require__.e(1967), __webpack_require__.e(3418), __webpack_require__.e(5913)]).then(__webpack_require__.bind(__webpack_require__, 93418));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(93418)
            ];
        }
    },
    ssr: false
});
var OneTap = function() {
    var dispatch = (0,es/* useDispatch */.I0)();
    var router = (0,next_router.useRouter)();
    var isAdminMode = (0,useAdminMode/* useAdminMode */.p)();
    var cookiebot = useCookieBot();
    var isAuthenticated = (0,es/* useSelector */.v9)(selectors_user/* selectIsAuthenticated */.vN);
    var ref = (0,react.useState)(false), isVisible = ref[0], setIsVisible = ref[1];
    var ref1 = (0,react.useState)(false), showMore = ref1[0], setShowMore = ref1[1];
    (0,react.useEffect)(function() {
        var routerAsPathNoPrams = router.asPath.split("?")[0];
        var isOnLandingPage = [
            routes/* ROUTES.enquiryLandingPage.regex */.Z.enquiryLandingPage.regex,
            routes/* ROUTES.enquiryLandingAltPage.regex */.Z.enquiryLandingAltPage.regex, 
        ].some(function(regex) {
            return regex.test(routerAsPathNoPrams);
        });
        var storageKeyExists = false;
        if ((0,utilities_system/* storageAvailable */.oZ)("localStorage")) {
            var storageKey = (0,utilities_system/* getWithExpiry */.jE)(constants/* constants.localStorageKey.oneTap */._G.localStorageKey.oneTap);
            storageKeyExists = !!storageKey;
        }
        var shouldHideOneTap = isOnLandingPage || storageKeyExists || cookiebot.isVisible;
        if (router.isReady) {
            if (shouldHideOneTap && isVisible) {
                setIsVisible(false);
            }
            if (!shouldHideOneTap && !isVisible) {
                var showTimer = setTimeout(function() {
                    setIsVisible(true);
                    (0,vehicle/* addToDataLayer */.Bk)({
                        event: "one-tap-view"
                    });
                    dispatch((0,actions_event/* postAnalyticsEvent */.gR)({
                        event: constants/* constants.eventTypes.oneTapComponentView */._G.eventTypes.oneTapComponentView
                    }));
                }, 1500);
                return function() {
                    clearTimeout(showTimer);
                };
            }
        }
    }, [
        dispatch,
        router,
        isVisible,
        cookiebot.isVisible
    ]);
    var onCloseOneTap = function() {
        if ((0,utilities_system/* storageAvailable */.oZ)("localStorage")) {
            var oneDay = 86400000;
            (0,utilities_system/* setWithExpiry */.w4)(constants/* constants.localStorageKey.oneTap */._G.localStorageKey.oneTap, true, oneDay);
        }
        (0,vehicle/* addToDataLayer */.Bk)({
            event: "social-one-tap",
            label: "close"
        });
        dispatch((0,actions_event/* postAnalyticsEvent */.gR)({
            event: constants/* constants.eventTypes.oneTapComponentAction */._G.eventTypes.oneTapComponentAction,
            payload: {
                label: "close"
            }
        }));
        setIsVisible(false);
    };
    var onLogIn = function(platform) {
        if (platform === "facebook") {
            (0,vehicle/* addToDataLayer */.Bk)({
                event: "social-one-tap",
                label: "facebook"
            });
            dispatch((0,actions_event/* postAnalyticsEvent */.gR)({
                event: constants/* constants.eventTypes.oneTapComponentAction */._G.eventTypes.oneTapComponentAction,
                payload: {
                    label: "facebook"
                }
            }));
            dispatch((0,user/* storeRedirectUrl */.Nt)(router.asPath));
            dispatch((0,user/* storeUsedSocialLogin */.F8)(true));
            (0,signInWithRedirect/* signInWithRedirect */.F)({
                provider: "Facebook"
            });
        }
        if (platform === "google") {
            (0,vehicle/* addToDataLayer */.Bk)({
                event: "social-one-tap",
                label: "google"
            });
            dispatch((0,actions_event/* postAnalyticsEvent */.gR)({
                event: constants/* constants.eventTypes.oneTapComponentAction */._G.eventTypes.oneTapComponentAction,
                payload: {
                    label: "google"
                }
            }));
            dispatch((0,user/* storeRedirectUrl */.Nt)(router.asPath));
            dispatch((0,user/* storeUsedSocialLogin */.F8)(true));
            (0,signInWithRedirect/* signInWithRedirect */.F)({
                provider: "Google"
            });
        }
        if (platform === "email") {
            (0,vehicle/* addToDataLayer */.Bk)({
                event: "social-one-tap",
                label: "email"
            });
            dispatch((0,actions_event/* postAnalyticsEvent */.gR)({
                event: constants/* constants.eventTypes.oneTapComponentAction */._G.eventTypes.oneTapComponentAction,
                payload: {
                    label: "email"
                }
            }));
            esm/* default.show */.ZP.show(AuthenticationModal, {
                initialStatus: constants/* STATUS_LOGIN */.NN
            });
        }
    };
    if (isAuthenticated || !isVisible || isAdminMode) {
        return null;
    }
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: "".concat((one_tap_module_default()).container, " one-tap-component"),
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: (one_tap_module_default()).header,
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: (one_tap_module_default())["top-line"],
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Icon, {
                                name: "KeyRound",
                                size: types_system/* Size.Small */.$u.Small
                            }),
                            " ",
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                children: "Unlock the best of LeaseLoco"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: (one_tap_module_default())["bottom-line"],
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                            children: "Log in to get the most out of LeaseLoco"
                        })
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: (one_tap_module_default())["login-wrapper"],
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: (one_tap_module_default()).message,
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                className: (one_tap_module_default()).text,
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
                                        src: "".concat(constants/* constants.imageHost.assets */._G.imageHost.assets, "/logos/icon.png"),
                                        alt: "",
                                        height: 20,
                                        width: 20
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                        children: "Log in to LeaseLoco with Google"
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Button/* Button */.z, {
                                hierarchy: Button/* ButtonHierarchy.BorderlessGray */.B.BorderlessGray,
                                size: types_system/* Size.Medium */.$u.Medium,
                                label: "",
                                icon: "X",
                                onClick: onCloseOneTap
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: (one_tap_module_default())["button-group"],
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("button", {
                                type: "button",
                                className: (one_tap_module_default()).button,
                                "data-type": "google",
                                onClick: function() {
                                    return onLogIn("google");
                                },
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                        className: (one_tap_module_default()).image,
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
                                            src: "".concat(constants/* constants.imageHost.assets */._G.imageHost.assets, "/general/google.svg"),
                                            alt: "",
                                            height: 18,
                                            width: 18
                                        })
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                        className: (one_tap_module_default()).label,
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                                children: "Continue with Google"
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                                children: "Link your Google account"
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                        className: (one_tap_module_default())["google-button"],
                                        children: "Continue"
                                    })
                                ]
                            }),
                            showMore ? /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("button", {
                                        type: "button",
                                        className: (one_tap_module_default()).button,
                                        "data-type": "facebook",
                                        onClick: function() {
                                            return onLogIn("facebook");
                                        },
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                className: (one_tap_module_default()).image,
                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
                                                    src: "".concat(constants/* constants.imageHost.assets */._G.imageHost.assets, "/icons/social/facebook.svg"),
                                                    alt: "",
                                                    height: 18,
                                                    width: 18
                                                })
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                className: (one_tap_module_default()).label,
                                                children: [
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                                        children: "Continue with Facebook"
                                                    }),
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                                        children: "Link your Facebook account"
                                                    })
                                                ]
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                className: (one_tap_module_default())["google-button"],
                                                children: "Continue"
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("button", {
                                        type: "button",
                                        className: (one_tap_module_default()).button,
                                        "data-type": "email",
                                        onClick: function() {
                                            return onLogIn("email");
                                        },
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                className: (one_tap_module_default()).image,
                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Icon, {
                                                    name: "Mail",
                                                    size: types_system/* Size.Small */.$u.Small
                                                })
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                className: (one_tap_module_default()).label,
                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                                    children: "Continue with Email"
                                                })
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                className: (one_tap_module_default())["google-button"],
                                                children: "Continue"
                                            })
                                        ]
                                    })
                                ]
                            }) : /*#__PURE__*/ (0,jsx_runtime.jsxs)("button", {
                                type: "button",
                                className: (one_tap_module_default()).button,
                                "data-type": "show-more",
                                onClick: function() {
                                    return setShowMore(true);
                                },
                                children: [
                                    "2 more options",
                                    " ",
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Icon, {
                                        name: "ChevronDown",
                                        size: types_system/* Size.Medium */.$u.Medium
                                    })
                                ]
                            })
                        ]
                    })
                ]
            })
        ]
    });
};

// EXTERNAL MODULE: ./components/styleguide/OneTap/one-tap-variant.module.scss
var one_tap_variant_module = __webpack_require__(9936);
var one_tap_variant_module_default = /*#__PURE__*/__webpack_require__.n(one_tap_variant_module);
;// CONCATENATED MODULE: ./components/styleguide/OneTap/OneTapVariant.tsx

















var OneTapVariant = function() {
    var dispatch = (0,es/* useDispatch */.I0)();
    var router = (0,next_router.useRouter)();
    var isAdminMode = (0,useAdminMode/* useAdminMode */.p)();
    var cookiebot = useCookieBot();
    var isAuthenticated = (0,es/* useSelector */.v9)(selectors_user/* selectIsAuthenticated */.vN);
    var ref = (0,react.useState)(false), isVisible = ref[0], setIsVisible = ref[1];
    (0,react.useEffect)(function() {
        var routerAsPathNoPrams = router.asPath.split("?")[0];
        var isOnLandingPage = [
            routes/* ROUTES.enquiryLandingPage.regex */.Z.enquiryLandingPage.regex,
            routes/* ROUTES.enquiryLandingAltPage.regex */.Z.enquiryLandingAltPage.regex, 
        ].some(function(regex) {
            return regex.test(routerAsPathNoPrams);
        });
        var storageKeyExists = false;
        if ((0,utilities_system/* storageAvailable */.oZ)("localStorage")) {
            var storageKey = (0,utilities_system/* getWithExpiry */.jE)(constants/* constants.localStorageKey.oneTap */._G.localStorageKey.oneTap);
            storageKeyExists = !!storageKey;
        }
        var shouldHideOneTap = isOnLandingPage || storageKeyExists || cookiebot.isVisible;
        if (router.isReady) {
            if (shouldHideOneTap && isVisible) {
                setIsVisible(false);
            }
            if (!shouldHideOneTap && !isVisible) {
                var showTimer = setTimeout(function() {
                    setIsVisible(true);
                    (0,vehicle/* addToDataLayer */.Bk)({
                        event: "one-tap-view"
                    });
                    dispatch((0,actions_event/* postAnalyticsEvent */.gR)({
                        event: constants/* constants.eventTypes.oneTapComponentView */._G.eventTypes.oneTapComponentView
                    }));
                }, 1500);
                return function() {
                    clearTimeout(showTimer);
                };
            }
        }
    }, [
        dispatch,
        router,
        isVisible,
        cookiebot.isVisible
    ]);
    var onCloseOneTap = function() {
        if ((0,utilities_system/* storageAvailable */.oZ)("localStorage")) {
            var oneDay = 86400000;
            (0,utilities_system/* setWithExpiry */.w4)(constants/* constants.localStorageKey.oneTap */._G.localStorageKey.oneTap, true, oneDay);
        }
        (0,vehicle/* addToDataLayer */.Bk)({
            event: "social-one-tap",
            label: "close"
        });
        dispatch((0,actions_event/* postAnalyticsEvent */.gR)({
            event: constants/* constants.eventTypes.oneTapComponentAction */._G.eventTypes.oneTapComponentAction,
            payload: {
                label: "close"
            }
        }));
        setIsVisible(false);
    };
    var onLogIn = function() {
        (0,vehicle/* addToDataLayer */.Bk)({
            event: "social-one-tap",
            label: "google"
        });
        dispatch((0,actions_event/* postAnalyticsEvent */.gR)({
            event: constants/* constants.eventTypes.oneTapComponentAction */._G.eventTypes.oneTapComponentAction,
            payload: {
                label: "google"
            }
        }));
        dispatch((0,user/* storeRedirectUrl */.Nt)(router.asPath));
        dispatch((0,user/* storeUsedSocialLogin */.F8)(true));
        (0,signInWithRedirect/* signInWithRedirect */.F)({
            provider: "Google"
        });
    };
    if (isAuthenticated || !isVisible || isAdminMode) {
        return null;
    }
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: "".concat((one_tap_variant_module_default()).container, " one-tap-component"),
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: (one_tap_variant_module_default()).header,
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: (one_tap_variant_module_default()).label,
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
                                src: "".concat(constants/* constants.imageHost.assets */._G.imageHost.assets, "/general/google.svg"),
                                alt: "Google Logo",
                                height: 20,
                                width: 20
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                children: "Sign in with Google"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Button/* Button */.z, {
                        hierarchy: "borderless-gray",
                        size: "md",
                        icon: "X",
                        onClick: onCloseOneTap
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: (one_tap_variant_module_default()).cta,
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                        className: (one_tap_variant_module_default()).leading,
                        children: "Use your Google account to sign in to Leaseloco.com"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("p", {
                        className: (one_tap_variant_module_default()).sub,
                        children: [
                            "No more passwords to remember. ",
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("br", {}),
                            "Signing in is fast, simple and secure."
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Button/* Button */.z, {
                        hierarchy: "filled",
                        size: "lg",
                        label: "Continue",
                        onClick: function() {
                            return onLogIn();
                        }
                    })
                ]
            })
        ]
    });
};

;// CONCATENATED MODULE: ./components/styleguide/OneTap/index.ts




/***/ }),

/***/ 7158:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ ROUTES; }
/* harmony export */ });
var ROUTES = {
    accountDetailsPage: {
        url: "/locospace/account-details",
        regex: /\/locospace\/account-details/
    },
    authPage: {
        url: "/auth",
        regex: /\/auth/
    },
    autoResetPasswordPage: {
        url: "/password/reset/:username/:verificationCode"
    },
    autoVerifyPage: {
        url: "/verify/:username/:verificationCode",
        regex: /\/verify\/(.+)\/([0-9]{0,10})$/
    },
    blogPage: {
        url: "/blog"
    },
    blogArticlePage: {
        url: "/blog/:slug"
    },
    blogAuthorsPage: {
        url: "/blog/authors"
    },
    businessLeasingPage: {
        url: "/business-leasing"
    },
    careersPage: {
        url: "/careers"
    },
    carSearchPage: {
        url: "/car-leasing/search",
        regex: /\/car-leasing\/search/
    },
    collectionsPage: {
        url: "/collections",
        regex: /\/collections/,
        title: "collections"
    },
    comparisonPage: {
        url: "/locospace/comparison",
        regex: /\/locospace\/comparison/
    },
    complaintsPage: {
        url: "/complaints"
    },
    cookiePolicyPage: {
        url: "/cookie-policy"
    },
    debugPage: {
        url: "/debug"
    },
    electricVehiclesPage: {
        url: "/electric-car-leasing"
    },
    ethicalCodeOfConductPage: {
        url: "/ethical-code-of-conduct"
    },
    enquiriesPage: {
        url: "/locospace/enquiries",
        regex: /\/locospace\/enquiries/
    },
    enquiryLandingPage: {
        url: "/ad/deal/:adReference",
        regex: /\/ad\/deal\/([a-z0-9-]{0,36})$/
    },
    enquiryLandingAltPage: {
        url: "/ad/deal-alt/:adReference",
        regex: /\/ad\/deal-alt\/([a-z0-9-]{0,36})$/
    },
    faqsPage: {
        url: "/faqs",
        regex: /\/faqs$/
    },
    faqsArticlePage: {
        url: "/faqs/:article"
    },
    forgotPasswordPage: {
        url: "/password"
    },
    guidesArticlePage: {
        url: "/guides/:category/:article",
        regex: /\/guides\/([a-z \w-]{0,50})\/([a-z \w-]{0,50})$/
    },
    guidesPage: {
        url: "/guides",
        regex: /\/guides/
    },
    guidesCategoryPage: {
        url: "/guides/:category",
        regex: /\/guides\/([a-z \w-]{0,50})$/
    },
    homePage: {
        url: "/",
        regex: /^\/$/
    },
    leasingCategoriesPage: {
        url: "/leasing-categories"
    },
    locoScorePage: {
        url: "/loco-score"
    },
    loginPage: {
        url: "/login"
    },
    logoutPage: {
        url: "/logout",
        regex: /\/logout$/
    },
    locoAiSearchPage: {
        url: "/loco-ai/search",
        regex: /\/loco-ai\/search/
    },
    manufacturerLandingPage: {
        url: "/:vehicleType-leasing/:manufacturer",
        regex: {
            default: /\/car-leasing\/(?!search)([a-z \w-]{0,50})$/,
            withPageNumber: /\/car-leasing\/(?!search)([a-z \w-]{0,50})(\?page=([0-9]{1,10}))$/,
            vanDefault: /\/van-leasing\/(?!search)([a-z \w-]{0,50})$/,
            vanWithPageNumber: /\/van-leasing\/(?!search)([a-z \w-]{0,50})(\?page=([0-9]{1,10}))$/
        }
    },
    newsletterSignUpPage: {
        url: "/newsletter/sign-up"
    },
    partnerCriteriaPage: {
        url: "/partner-criteria"
    },
    pcpSavingsPage: {
        url: "/pcp-savings"
    },
    personalCarLeasingPage: {
        url: "/personal-car-leasing"
    },
    privacyPolicyPage: {
        url: "/privacy-policy"
    },
    priceAlertsPage: {
        url: "/locospace/price-alerts",
        regex: /\/locospace\/price-alerts/
    },
    radioPage: {
        url: "/radio"
    },
    rangeLandingPage: {
        url: "/:vehicleType-leasing/:manufacturer/:model",
        regex: {
            default: /\/car-leasing\/(?!search)([a-z \w-]{0,50})\/([a-z \w-]{0,60})$/,
            withPageNumber: /\/car-leasing\/(?!search)([a-z \w-]{0,50})\/([a-z \w-]{0,60})(\?page=([0-9]{1,10}))$/,
            vanDefault: /\/van-leasing\/(?!search)([a-z \w-]{0,50})\/([a-z \w-]{0,60})$/,
            vanWithPageNumber: /\/van-leasing\/(?!search)([a-z \w-]{0,50})\/([a-z \w-]{0,60})(\?page=([0-9]{1,10}))$/
        }
    },
    referAFriendPage: {
        url: "/locospace/refer-a-friend",
        regex: /\/locospace\/refer-a-friend/
    },
    referAFriendTermsPage: {
        url: "/locospace/refer-a-friend/terms"
    },
    referRegisterPage: {
        url: "/refer/:referralCode",
        regex: /\/refer\/([a-z0-9 \w-]{0,20})$/
    },
    registerPage: {
        url: "/register"
    },
    rewardsPage: {
        url: "/locospace/rewards",
        regex: /\/locospace\/rewards/
    },
    rewardsAndReferralsPage: {
        url: "/rewards-and-referrals",
        regex: /\/rewards-and-referrals$/
    },
    rewardsTermsPage: {
        url: "/locospace/rewards/terms"
    },
    savedSearchPage: {
        url: "/locospace/saved-searches",
        regex: /\/locospace\/saved-searches/
    },
    searchPage: {
        url: "/:vehicleType-leasing/search",
        regex: {
            default: /\/car-leasing\/search$/,
            withPageNumber: /\/car-leasing\/search(\?page=([0-9]{1,10}))$/,
            vanDefault: /\/van-leasing\/search$/,
            vanWithPageNumber: /\/van-leasing\/search(\?page=([0-9]{1,10}))$/
        }
    },
    searchPageWithReference: {
        url: "/:vehicleType-leasing/search/:reference",
        regex: {
            default: /\/car-leasing\/search\/([a-z0-9 \w-]{0,32})$/,
            withPageNumber: /\/car-leasing\/search\/([a-z0-9 \w-]{0,32})(\?page=([0-9]{1,10}))$/,
            vanDefault: /\/van-leasing\/search\/([a-z0-9 \w-]{0,32})$/,
            vanWithPageNumber: /\/van-leasing\/search\/([a-z0-9 \w-]{0,32})(\?page=([0-9]{1,10}))$/
        }
    },
    searchPageWithManufacturer: {
        url: "/:vehicleType-leasing/search/:manufacturer",
        regex: {
            default: /\/car-leasing\/search\/([a-z \w-]{0,50})$/,
            withPageNumber: /\/car-leasing\/search\/([a-z \w-]{0,50})(\?page=([0-9]{1,10}))$/,
            vanDefault: /\/van-leasing\/search\/([a-z \w-]{0,50})$/,
            vanWithPageNumber: /\/van-leasing\/search\/([a-z \w-]{0,50})(\?page=([0-9]{1,10}))$/
        }
    },
    searchPageWithModel: {
        url: "/:vehicleType-leasing/search/:manufacturer/:model",
        regex: {
            default: /\/car-leasing\/search\/([a-z \w-]{0,50})\/([a-z \w-]{0,60})$/,
            withPageNumber: /\/car-leasing\/search\/([a-z \w-]{0,50})\/([a-z \w-]{0,60})(\?page=([0-9]{1,10}))$/,
            vanDefault: /\/van-leasing\/search\/([a-z \w-]{0,50})\/([a-z \w-]{0,60})$/,
            vanWithPageNumber: /\/van-leasing\/search\/([a-z \w-]{0,50})\/([a-z \w-]{0,60})(\?page=([0-9]{1,10}))$/
        }
    },
    termsPage: {
        url: "/terms"
    },
    treatingCustomersFairlyPage: {
        url: "/treating-customers-fairly"
    },
    tvPage: {
        url: "/tv",
        regex: /\/tv$/
    },
    vanHomePage: {
        url: "/van-leasing",
        regex: /\/van-leasing$/
    },
    vanSearchPage: {
        url: "/van-leasing/search",
        regex: /\/van-leasing\/search/
    },
    vehicleWithLeaseProfilePage: {
        url: "/:vehicleType-leasing/:manufacturer/:model/:derivative/:vehicleId/:leaseProfile",
        regex: {
            car: /\/car-leasing\/([a-z \w-]{0,50})\/([a-z0-9 \w-]{0,50})\/([a-z \w-]{0,60})\/([0-9]{0,10})\/([0-9-]{0,15})$/,
            van: /\/van-leasing\/([a-z \w-]{0,50})\/([a-z0-9 \w-]{0,50})\/([a-z \w-]{0,60})\/([0-9]{0,10})\/([0-9-]{0,15})$/
        }
    },
    vehicleWithLeaseProfileAndDealIdPage: {
        url: "/:vehicleType-leasing/:manufacturer/:model/:derivative/:vehicleId/:leaseProfile/:dealId",
        regex: {
            car: /\/car-leasing\/([a-z \w-]{0,50})\/([a-z0-9 \w-]{0,50})\/([a-z \w-]{0,60})\/([0-9]{0,10})\/([0-9-]{0,15})\/([a-z \w-]{0,50})$/,
            van: /\/van-leasing\/([a-z \w-]{0,50})\/([a-z0-9 \w-]{0,50})\/([a-z \w-]{0,60})\/([0-9]{0,10})\/([0-9-]{0,15})\/([a-z \w-]{0,50})$/
        }
    },
    vehicleConfigPage: {
        url: "/:vehicleType-leasing/:manufacturer/:model/:derivative/:vehicleId/:leaseProfile/:dealId/config",
        regex: {
            car: /\/car-leasing\/([a-z \w-]{0,50})\/([a-z0-9 \w-]{0,50})\/([a-z \w-]{0,60})\/([0-9]{0,10})\/([0-9-]{0,15})\/([a-z \w-]{0,50})\/config$/,
            van: /\/van-leasing\/([a-z \w-]{0,50})\/([a-z0-9 \w-]{0,50})\/([a-z \w-]{0,60})\/([0-9]{0,10})\/([0-9-]{0,15})\/([a-z \w-]{0,50})\/config$/
        },
        title: {
            car: "car-config",
            van: "van-config"
        }
    },
    vehicleDealsPage: {
        url: "/:vehicleType-leasing/:manufacturer/:model/:derivative/:vehicleId/:leaseProfile/:dealId/deals",
        regex: {
            car: /\/car-leasing\/([a-z \w-]{0,50})\/([a-z0-9 \w-]{0,50})\/([a-z \w-]{0,60})\/([0-9]{0,10})\/([0-9-]{0,15})\/([a-z \w-]{0,50})\/deals$/,
            van: /\/van-leasing\/([a-z \w-]{0,50})\/([a-z0-9 \w-]{0,50})\/([a-z \w-]{0,60})\/([0-9]{0,10})\/([0-9-]{0,15})\/([a-z \w-]{0,50})\/deals$/
        },
        title: {
            car: "car-deals",
            van: "van-deals"
        }
    },
    vehicleEnquiredPage: {
        url: "/:vehicleType-leasing/:manufacturer/:model/:derivative/:vehicleId/:leaseProfile/:dealId/enquired",
        regex: {
            car: /\/car-leasing\/([a-z \w-]{0,50})\/([a-z0-9 \w-]{0,50})\/([a-z \w-]{0,60})\/([0-9]{0,10})\/([0-9-]{0,15})\/([a-z \w-]{0,50})\/enquired$/,
            van: /\/van-leasing\/([a-z \w-]{0,50})\/([a-z0-9 \w-]{0,50})\/([a-z \w-]{0,60})\/([0-9]{0,10})\/([0-9-]{0,15})\/([a-z \w-]{0,50})\/enquired$/
        },
        title: {
            car: "car-enquired",
            van: "van-enquired"
        }
    },
    verifyEnquiryPage: {
        url: "/verify-enquiry/:type/:id",
        regex: /\/verify-enquiry\/p|e\/([a-z0-9 \w-]{0,6})$/
    },
    whyLeasePage: {
        url: "/why-lease",
        regex: /\/why-lease$/
    }
};


/***/ }),

/***/ 57190:
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", ({
    value: true
}));
var _slicedToArray = (__webpack_require__(39274)/* ["default"] */ .Z);
Object.defineProperty(exports, "__esModule", ({
    value: true
}));
exports.useIntersection = useIntersection;
var _react = __webpack_require__(67294);
var _requestIdleCallback = __webpack_require__(9311);
var hasIntersectionObserver = typeof IntersectionObserver === "function";
var observers = new Map();
var idList = [];
function createObserver(options) {
    var id = {
        root: options.root || null,
        margin: options.rootMargin || ""
    };
    var existing = idList.find(function(obj) {
        return obj.root === id.root && obj.margin === id.margin;
    });
    var instance;
    if (existing) {
        instance = observers.get(existing);
        if (instance) {
            return instance;
        }
    }
    var elements = new Map();
    var observer = new IntersectionObserver(function(entries) {
        entries.forEach(function(entry) {
            var callback = elements.get(entry.target);
            var isVisible = entry.isIntersecting || entry.intersectionRatio > 0;
            if (callback && isVisible) {
                callback(isVisible);
            }
        });
    }, options);
    instance = {
        id: id,
        observer: observer,
        elements: elements
    };
    idList.push(id);
    observers.set(id, instance);
    return instance;
}
function observe(element, callback, options) {
    var ref = createObserver(options), id = ref.id, observer = ref.observer, elements = ref.elements;
    elements.set(element, callback);
    observer.observe(element);
    return function unobserve() {
        elements.delete(element);
        observer.unobserve(element);
        // Destroy observer when there's nothing left to watch:
        if (elements.size === 0) {
            observer.disconnect();
            observers.delete(id);
            var index = idList.findIndex(function(obj) {
                return obj.root === id.root && obj.margin === id.margin;
            });
            if (index > -1) {
                idList.splice(index, 1);
            }
        }
    };
}
function useIntersection(param) {
    var rootRef = param.rootRef, rootMargin = param.rootMargin, disabled = param.disabled;
    var isDisabled = disabled || !hasIntersectionObserver;
    var ref = _slicedToArray((0, _react).useState(false), 2), visible = ref[0], setVisible = ref[1];
    var ref1 = _slicedToArray((0, _react).useState(null), 2), element = ref1[0], setElement = ref1[1];
    (0, _react).useEffect(function() {
        if (hasIntersectionObserver) {
            if (isDisabled || visible) return;
            if (element && element.tagName) {
                var unobserve = observe(element, function(isVisible) {
                    return isVisible && setVisible(isVisible);
                }, {
                    root: rootRef == null ? void 0 : rootRef.current,
                    rootMargin: rootMargin
                });
                return unobserve;
            }
        } else {
            if (!visible) {
                var idleCallback = (0, _requestIdleCallback).requestIdleCallback(function() {
                    return setVisible(true);
                });
                return function() {
                    return (0, _requestIdleCallback).cancelIdleCallback(idleCallback);
                };
            }
        }
    }, [
        element,
        isDisabled,
        rootMargin,
        rootRef,
        visible
    ]);
    var resetVisible = (0, _react).useCallback(function() {
        setVisible(false);
    }, []);
    return [
        setElement,
        visible,
        resetVisible
    ];
}
if ((typeof exports.default === "function" || typeof exports.default === "object" && exports.default !== null) && typeof exports.default.__esModule === "undefined") {
    Object.defineProperty(exports.default, "__esModule", {
        value: true
    });
    Object.assign(exports.default, exports);
    module.exports = exports.default;
} //# sourceMappingURL=use-intersection.js.map


/***/ }),

/***/ 16693:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "$u": function() { return /* binding */ Size; },
/* harmony export */   "Q2": function() { return /* binding */ Theme; },
/* harmony export */   "ih": function() { return /* binding */ TestStatus; }
/* harmony export */ });
/* unused harmony export LoadingStatus */
var Theme;
(function(Theme) {
    Theme["light"] = "light";
    Theme["dark"] = "dark";
})(Theme || (Theme = {}));
var TestStatus;
(function(TestStatus) {
    TestStatus["Default"] = "default";
    TestStatus["Fail"] = "fail";
    TestStatus["Pass"] = "pass";
})(TestStatus || (TestStatus = {}));
var Size;
(function(Size) {
    Size["ExtraSmall"] = "xs";
    Size["Small"] = "sm";
    Size["Medium"] = "md";
    Size["Large"] = "lg";
    Size["ExtraLarge"] = "xl";
    Size["ExtraExtraLarge"] = "2xl";
})(Size || (Size = {}));
var LoadingStatus;
(function(LoadingStatus) {
    LoadingStatus["Loading"] = "loading";
    LoadingStatus["Complete"] = "complete";
})(LoadingStatus || (LoadingStatus = {}));


/***/ }),

/***/ 11069:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"main":"button_main___eQSM","loader":"button_loader__U44JW","label":"button_label__K7r_v","rotate":"button_rotate__kRBLq","loader-container":"button_loader-container__Ik9J_","loader-dots":"button_loader-dots___PKOj","loaderDots":"button_loaderDots___4DhB","phAnimation":"button_phAnimation__XeQ3d"};

/***/ }),

/***/ 9936:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"container":"one-tap-variant_container___Xs0s","header":"one-tap-variant_header__IAOEc","label":"one-tap-variant_label__T3eBw","cta":"one-tap-variant_cta__Q320Q","leading":"one-tap-variant_leading__Vo55I","sub":"one-tap-variant_sub__u5xgT","google-button":"one-tap-variant_google-button__QqJBF","phAnimation":"one-tap-variant_phAnimation__t_Ygs"};

/***/ }),

/***/ 29688:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"container":"one-tap_container__MmrNd","header":"one-tap_header__qZvdh","top-line":"one-tap_top-line__H3PFt","bottom-line":"one-tap_bottom-line__R_6h_","login-wrapper":"one-tap_login-wrapper__zQidc","message":"one-tap_message__9YiWH","text":"one-tap_text__DRYL2","button-group":"one-tap_button-group__bTb6L","button":"one-tap_button__rQNxL","image":"one-tap_image__Sp5SY","label":"one-tap_label__uRbBm","google-button":"one-tap_google-button__jm16K","phAnimation":"one-tap_phAnimation__GAYOh"};

/***/ }),

/***/ 53136:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "AL": function() { return /* binding */ AuthErrorStrings; },
/* harmony export */   "By": function() { return /* binding */ validationErrorMap; },
/* harmony export */   "kq": function() { return /* binding */ AuthErrorCodes; }
/* harmony export */ });
/* harmony import */ var _errors_types_validation_mjs__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(55227);


// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
const validationErrorMap = {
    [_errors_types_validation_mjs__WEBPACK_IMPORTED_MODULE_0__/* .AuthValidationErrorCode.EmptyChallengeResponse */ .X.EmptyChallengeResponse]: {
        message: 'challengeResponse is required to confirmSignIn',
    },
    [_errors_types_validation_mjs__WEBPACK_IMPORTED_MODULE_0__/* .AuthValidationErrorCode.EmptyConfirmResetPasswordUsername */ .X.EmptyConfirmResetPasswordUsername]: {
        message: 'username is required to confirmResetPassword',
    },
    [_errors_types_validation_mjs__WEBPACK_IMPORTED_MODULE_0__/* .AuthValidationErrorCode.EmptyConfirmSignUpCode */ .X.EmptyConfirmSignUpCode]: {
        message: 'code is required to confirmSignUp',
    },
    [_errors_types_validation_mjs__WEBPACK_IMPORTED_MODULE_0__/* .AuthValidationErrorCode.EmptyConfirmSignUpUsername */ .X.EmptyConfirmSignUpUsername]: {
        message: 'username is required to confirmSignUp',
    },
    [_errors_types_validation_mjs__WEBPACK_IMPORTED_MODULE_0__/* .AuthValidationErrorCode.EmptyConfirmResetPasswordConfirmationCode */ .X.EmptyConfirmResetPasswordConfirmationCode]: {
        message: 'confirmationCode is required to confirmResetPassword',
    },
    [_errors_types_validation_mjs__WEBPACK_IMPORTED_MODULE_0__/* .AuthValidationErrorCode.EmptyConfirmResetPasswordNewPassword */ .X.EmptyConfirmResetPasswordNewPassword]: {
        message: 'newPassword is required to confirmResetPassword',
    },
    [_errors_types_validation_mjs__WEBPACK_IMPORTED_MODULE_0__/* .AuthValidationErrorCode.EmptyResendSignUpCodeUsername */ .X.EmptyResendSignUpCodeUsername]: {
        message: 'username is required to confirmSignUp',
    },
    [_errors_types_validation_mjs__WEBPACK_IMPORTED_MODULE_0__/* .AuthValidationErrorCode.EmptyResetPasswordUsername */ .X.EmptyResetPasswordUsername]: {
        message: 'username is required to resetPassword',
    },
    [_errors_types_validation_mjs__WEBPACK_IMPORTED_MODULE_0__/* .AuthValidationErrorCode.EmptySignInPassword */ .X.EmptySignInPassword]: {
        message: 'password is required to signIn',
    },
    [_errors_types_validation_mjs__WEBPACK_IMPORTED_MODULE_0__/* .AuthValidationErrorCode.EmptySignInUsername */ .X.EmptySignInUsername]: {
        message: 'username is required to signIn',
    },
    [_errors_types_validation_mjs__WEBPACK_IMPORTED_MODULE_0__/* .AuthValidationErrorCode.EmptySignUpPassword */ .X.EmptySignUpPassword]: {
        message: 'password is required to signUp',
    },
    [_errors_types_validation_mjs__WEBPACK_IMPORTED_MODULE_0__/* .AuthValidationErrorCode.EmptySignUpUsername */ .X.EmptySignUpUsername]: {
        message: 'username is required to signUp',
    },
    [_errors_types_validation_mjs__WEBPACK_IMPORTED_MODULE_0__/* .AuthValidationErrorCode.CustomAuthSignInPassword */ .X.CustomAuthSignInPassword]: {
        message: 'A password is not needed when signing in with CUSTOM_WITHOUT_SRP',
        recoverySuggestion: 'Do not include a password in your signIn call.',
    },
    [_errors_types_validation_mjs__WEBPACK_IMPORTED_MODULE_0__/* .AuthValidationErrorCode.IncorrectMFAMethod */ .X.IncorrectMFAMethod]: {
        message: 'Incorrect MFA method was chosen. It should be either SMS or TOTP',
        recoverySuggestion: 'Try to pass TOTP or SMS as the challengeResponse',
    },
    [_errors_types_validation_mjs__WEBPACK_IMPORTED_MODULE_0__/* .AuthValidationErrorCode.EmptyVerifyTOTPSetupCode */ .X.EmptyVerifyTOTPSetupCode]: {
        message: 'code is required to verifyTotpSetup',
    },
    [_errors_types_validation_mjs__WEBPACK_IMPORTED_MODULE_0__/* .AuthValidationErrorCode.EmptyUpdatePassword */ .X.EmptyUpdatePassword]: {
        message: 'oldPassword and newPassword are required to changePassword',
    },
    [_errors_types_validation_mjs__WEBPACK_IMPORTED_MODULE_0__/* .AuthValidationErrorCode.EmptyConfirmUserAttributeCode */ .X.EmptyConfirmUserAttributeCode]: {
        message: 'confirmation code is required to confirmUserAttribute',
    },
};
// TODO: delete this code when the Auth class is removed.
var AuthErrorStrings;
(function (AuthErrorStrings) {
    AuthErrorStrings["DEFAULT_MSG"] = "Authentication Error";
    AuthErrorStrings["EMPTY_EMAIL"] = "Email cannot be empty";
    AuthErrorStrings["EMPTY_PHONE"] = "Phone number cannot be empty";
    AuthErrorStrings["EMPTY_USERNAME"] = "Username cannot be empty";
    AuthErrorStrings["INVALID_USERNAME"] = "The username should either be a string or one of the sign in types";
    AuthErrorStrings["EMPTY_PASSWORD"] = "Password cannot be empty";
    AuthErrorStrings["EMPTY_CODE"] = "Confirmation code cannot be empty";
    AuthErrorStrings["SIGN_UP_ERROR"] = "Error creating account";
    AuthErrorStrings["NO_MFA"] = "No valid MFA method provided";
    AuthErrorStrings["INVALID_MFA"] = "Invalid MFA type";
    AuthErrorStrings["EMPTY_CHALLENGE"] = "Challenge response cannot be empty";
    AuthErrorStrings["NO_USER_SESSION"] = "Failed to get the session because the user is empty";
    AuthErrorStrings["NETWORK_ERROR"] = "Network Error";
    AuthErrorStrings["DEVICE_CONFIG"] = "Device tracking has not been configured in this User Pool";
    AuthErrorStrings["AUTOSIGNIN_ERROR"] = "Please use your credentials to sign in";
    AuthErrorStrings["OAUTH_ERROR"] = "Couldn't finish OAuth flow, check your User Pool HostedUI settings";
})(AuthErrorStrings || (AuthErrorStrings = {}));
var AuthErrorCodes;
(function (AuthErrorCodes) {
    AuthErrorCodes["SignInException"] = "SignInException";
    AuthErrorCodes["OAuthSignInError"] = "OAuthSignInException";
})(AuthErrorCodes || (AuthErrorCodes = {}));


//# sourceMappingURL=AuthErrorStrings.mjs.map


/***/ }),

/***/ 55227:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "X": function() { return /* binding */ AuthValidationErrorCode; }
/* harmony export */ });
// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
var AuthValidationErrorCode;
(function (AuthValidationErrorCode) {
    AuthValidationErrorCode["EmptySignInUsername"] = "EmptySignInUsername";
    AuthValidationErrorCode["EmptySignInPassword"] = "EmptySignInPassword";
    AuthValidationErrorCode["CustomAuthSignInPassword"] = "CustomAuthSignInPassword";
    AuthValidationErrorCode["EmptySignUpUsername"] = "EmptySignUpUsername";
    AuthValidationErrorCode["EmptySignUpPassword"] = "EmptySignUpPassword";
    AuthValidationErrorCode["EmptyConfirmSignUpUsername"] = "EmptyConfirmSignUpUsername";
    AuthValidationErrorCode["EmptyConfirmSignUpCode"] = "EmptyConfirmSignUpCode";
    AuthValidationErrorCode["EmptyResendSignUpCodeUsername"] = "EmptyresendSignUpCodeUsername";
    AuthValidationErrorCode["EmptyChallengeResponse"] = "EmptyChallengeResponse";
    AuthValidationErrorCode["EmptyConfirmResetPasswordUsername"] = "EmptyConfirmResetPasswordUsername";
    AuthValidationErrorCode["EmptyConfirmResetPasswordNewPassword"] = "EmptyConfirmResetPasswordNewPassword";
    AuthValidationErrorCode["EmptyConfirmResetPasswordConfirmationCode"] = "EmptyConfirmResetPasswordConfirmationCode";
    AuthValidationErrorCode["EmptyResetPasswordUsername"] = "EmptyResetPasswordUsername";
    AuthValidationErrorCode["EmptyVerifyTOTPSetupCode"] = "EmptyVerifyTOTPSetupCode";
    AuthValidationErrorCode["EmptyConfirmUserAttributeCode"] = "EmptyConfirmUserAttributeCode";
    AuthValidationErrorCode["IncorrectMFAMethod"] = "IncorrectMFAMethod";
    AuthValidationErrorCode["EmptyUpdatePassword"] = "EmptyUpdatePassword";
})(AuthValidationErrorCode || (AuthValidationErrorCode = {}));


//# sourceMappingURL=validation.mjs.map


/***/ }),

/***/ 66398:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "t": function() { return /* binding */ getCurrentUser_getCurrentUser; }
});

// EXTERNAL MODULE: ./node_modules/@aws-amplify/core/dist/esm/singleton/Amplify.mjs + 1 modules
var Amplify = __webpack_require__(78599);
// EXTERNAL MODULE: ./node_modules/@aws-amplify/core/dist/esm/singleton/Auth/utils/index.mjs + 1 modules
var utils = __webpack_require__(33461);
// EXTERNAL MODULE: ./node_modules/@aws-amplify/auth/dist/esm/providers/cognito/utils/types.mjs
var types = __webpack_require__(76566);
;// CONCATENATED MODULE: ./node_modules/@aws-amplify/auth/dist/esm/providers/cognito/apis/internal/getCurrentUser.mjs



// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
const getCurrentUser = async (amplify) => {
    const authConfig = amplify.getConfig().Auth?.Cognito;
    (0,utils/* assertTokenProviderConfig */.FG)(authConfig);
    const tokens = await amplify.Auth.getTokens({ forceRefresh: false });
    (0,types/* assertAuthTokens */.CA)(tokens);
    const { 'cognito:username': username, sub } = tokens.idToken?.payload ?? {};
    const authUser = {
        username: username,
        userId: sub,
    };
    const signInDetails = getSignInDetailsFromTokens(tokens);
    if (signInDetails) {
        authUser.signInDetails = signInDetails;
    }
    return authUser;
};
function getSignInDetailsFromTokens(tokens) {
    return tokens?.signInDetails;
}


//# sourceMappingURL=getCurrentUser.mjs.map

;// CONCATENATED MODULE: ./node_modules/@aws-amplify/auth/dist/esm/providers/cognito/apis/getCurrentUser.mjs



// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
/**
 * Gets the current user from the idToken.
 *
 * @param input -  The GetCurrentUserInput object.
 * @returns GetCurrentUserOutput
 * @throws - {@link InitiateAuthException} - Thrown when the service fails to refresh the tokens.
 * @throws AuthTokenConfigException - Thrown when the token provider config is invalid.
 */
const getCurrentUser_getCurrentUser = async () => {
    return getCurrentUser(Amplify/* Amplify */.d);
};


//# sourceMappingURL=getCurrentUser.mjs.map


/***/ }),

/***/ 60739:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "B": function() { return /* binding */ getRedirectUrl; }
/* harmony export */ });
/* harmony import */ var _errors_constants_mjs__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(79509);


// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
/** @internal */
function getRedirectUrl(redirects) {
    const redirectUrlFromTheSameOrigin = redirects?.find(isSameOriginAndPathName) ??
        redirects?.find(isTheSameDomain);
    const redirectUrlFromDifferentOrigin = redirects?.find(isHttps) ?? redirects?.find(isHttp);
    if (redirectUrlFromTheSameOrigin) {
        return redirectUrlFromTheSameOrigin;
    }
    else if (redirectUrlFromDifferentOrigin) {
        throw _errors_constants_mjs__WEBPACK_IMPORTED_MODULE_0__/* .invalidOriginException */ .VL;
    }
    throw _errors_constants_mjs__WEBPACK_IMPORTED_MODULE_0__/* .invalidRedirectException */ .vC;
}
// origin + pathname => https://example.com/app
const isSameOriginAndPathName = (redirect) => redirect.startsWith(String(window.location.origin + window.location.pathname ?? '/'));
// domain => outlook.live.com, github.com
const isTheSameDomain = (redirect) => redirect.includes(String(window.location.hostname));
const isHttp = (redirect) => redirect.startsWith('http://');
const isHttps = (redirect) => redirect.startsWith('https://');


//# sourceMappingURL=getRedirectUrl.mjs.map


/***/ }),

/***/ 84574:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "R": function() { return /* binding */ DefaultOAuthStore; }
/* harmony export */ });
/* harmony import */ var _aws_amplify_core_internals_utils__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(33461);
/* harmony import */ var _tokenProvider_TokenStore_mjs__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(25270);
/* harmony import */ var _types_mjs__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(76566);




// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
const V5_HOSTED_UI_KEY = 'amplify-signin-with-hostedUI';
const name = 'CognitoIdentityServiceProvider';
class DefaultOAuthStore {
    constructor(keyValueStorage) {
        this.keyValueStorage = keyValueStorage;
    }
    async clearOAuthInflightData() {
        (0,_aws_amplify_core_internals_utils__WEBPACK_IMPORTED_MODULE_0__/* .assertTokenProviderConfig */ .FG)(this.cognitoConfig);
        const authKeys = createKeysForAuthStorage(name, this.cognitoConfig.userPoolClientId);
        await Promise.all([
            this.keyValueStorage.removeItem(authKeys.inflightOAuth),
            this.keyValueStorage.removeItem(authKeys.oauthPKCE),
            this.keyValueStorage.removeItem(authKeys.oauthState),
        ]);
    }
    async clearOAuthData() {
        (0,_aws_amplify_core_internals_utils__WEBPACK_IMPORTED_MODULE_0__/* .assertTokenProviderConfig */ .FG)(this.cognitoConfig);
        const authKeys = createKeysForAuthStorage(name, this.cognitoConfig.userPoolClientId);
        await this.clearOAuthInflightData();
        await this.keyValueStorage.removeItem(V5_HOSTED_UI_KEY); // remove in case a customer migrated an App from v5 to v6
        return this.keyValueStorage.removeItem(authKeys.oauthSignIn);
    }
    loadOAuthState() {
        (0,_aws_amplify_core_internals_utils__WEBPACK_IMPORTED_MODULE_0__/* .assertTokenProviderConfig */ .FG)(this.cognitoConfig);
        const authKeys = createKeysForAuthStorage(name, this.cognitoConfig.userPoolClientId);
        return this.keyValueStorage.getItem(authKeys.oauthState);
    }
    storeOAuthState(state) {
        (0,_aws_amplify_core_internals_utils__WEBPACK_IMPORTED_MODULE_0__/* .assertTokenProviderConfig */ .FG)(this.cognitoConfig);
        const authKeys = createKeysForAuthStorage(name, this.cognitoConfig.userPoolClientId);
        return this.keyValueStorage.setItem(authKeys.oauthState, state);
    }
    loadPKCE() {
        (0,_aws_amplify_core_internals_utils__WEBPACK_IMPORTED_MODULE_0__/* .assertTokenProviderConfig */ .FG)(this.cognitoConfig);
        const authKeys = createKeysForAuthStorage(name, this.cognitoConfig.userPoolClientId);
        return this.keyValueStorage.getItem(authKeys.oauthPKCE);
    }
    storePKCE(pkce) {
        (0,_aws_amplify_core_internals_utils__WEBPACK_IMPORTED_MODULE_0__/* .assertTokenProviderConfig */ .FG)(this.cognitoConfig);
        const authKeys = createKeysForAuthStorage(name, this.cognitoConfig.userPoolClientId);
        return this.keyValueStorage.setItem(authKeys.oauthPKCE, pkce);
    }
    setAuthConfig(authConfigParam) {
        this.cognitoConfig = authConfigParam;
    }
    async loadOAuthInFlight() {
        (0,_aws_amplify_core_internals_utils__WEBPACK_IMPORTED_MODULE_0__/* .assertTokenProviderConfig */ .FG)(this.cognitoConfig);
        const authKeys = createKeysForAuthStorage(name, this.cognitoConfig.userPoolClientId);
        return ((await this.keyValueStorage.getItem(authKeys.inflightOAuth)) === 'true');
    }
    async storeOAuthInFlight(inflight) {
        (0,_aws_amplify_core_internals_utils__WEBPACK_IMPORTED_MODULE_0__/* .assertTokenProviderConfig */ .FG)(this.cognitoConfig);
        const authKeys = createKeysForAuthStorage(name, this.cognitoConfig.userPoolClientId);
        await this.keyValueStorage.setItem(authKeys.inflightOAuth, `${inflight}`);
    }
    async loadOAuthSignIn() {
        (0,_aws_amplify_core_internals_utils__WEBPACK_IMPORTED_MODULE_0__/* .assertTokenProviderConfig */ .FG)(this.cognitoConfig);
        const authKeys = createKeysForAuthStorage(name, this.cognitoConfig.userPoolClientId);
        const isLegacyHostedUISignIn = await this.keyValueStorage.getItem(V5_HOSTED_UI_KEY);
        const [isOAuthSignIn, preferPrivateSession] = (await this.keyValueStorage.getItem(authKeys.oauthSignIn))?.split(',') ??
            [];
        return {
            isOAuthSignIn: isOAuthSignIn === 'true' || isLegacyHostedUISignIn === 'true',
            preferPrivateSession: preferPrivateSession === 'true',
        };
    }
    async storeOAuthSignIn(oauthSignIn, preferPrivateSession = false) {
        (0,_aws_amplify_core_internals_utils__WEBPACK_IMPORTED_MODULE_0__/* .assertTokenProviderConfig */ .FG)(this.cognitoConfig);
        const authKeys = createKeysForAuthStorage(name, this.cognitoConfig.userPoolClientId);
        await this.keyValueStorage.setItem(authKeys.oauthSignIn, `${oauthSignIn},${preferPrivateSession}`);
    }
}
const createKeysForAuthStorage = (provider, identifier) => {
    return (0,_tokenProvider_TokenStore_mjs__WEBPACK_IMPORTED_MODULE_1__/* .getAuthStorageKeys */ ._X)(_types_mjs__WEBPACK_IMPORTED_MODULE_2__/* .OAuthStorageKeys */ .Bx)(provider, identifier);
};


//# sourceMappingURL=signInWithRedirectStore.mjs.map


/***/ }),

/***/ 88357:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "W": function() { return /* binding */ getAuthUserAgentValue; }
/* harmony export */ });
/* harmony import */ var _aws_amplify_core_internals_utils__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(51847);
/* harmony import */ var _aws_amplify_core_internals_utils__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(90005);


// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
const getAuthUserAgentValue = (action, customUserAgentDetails) => (0,_aws_amplify_core_internals_utils__WEBPACK_IMPORTED_MODULE_0__/* .getAmplifyUserAgent */ .Zm)({
    category: _aws_amplify_core_internals_utils__WEBPACK_IMPORTED_MODULE_1__/* .Category.Auth */ .WD.Auth,
    action,
    ...customUserAgentDetails,
});


//# sourceMappingURL=getAuthUserAgentValue.mjs.map


/***/ }),

/***/ 92535:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "A": function() { return /* binding */ openAuthSession; }
/* harmony export */ });
// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
const openAuthSession = async (url) => {
    if (!window?.location) {
        return;
    }
    // enforce HTTPS
    window.location.href = url.replace('http://', 'https://');
};


//# sourceMappingURL=openAuthSession.mjs.map


/***/ }),

/***/ 44747:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ _objectWithoutProperties; }
});

;// CONCATENATED MODULE: ./node_modules/next/node_modules/@swc/helpers/src/_object_without_properties_loose.mjs
function _objectWithoutPropertiesLoose(source, excluded) {
  if (source == null) return {};
  var target = {};
  var sourceKeys = Object.keys(source);
  var key, i;

  for (i = 0; i < sourceKeys.length; i++) {
    key = sourceKeys[i];
    if (excluded.indexOf(key) >= 0) continue;
    target[key] = source[key];
  }

  return target;
}

;// CONCATENATED MODULE: ./node_modules/next/node_modules/@swc/helpers/src/_object_without_properties.mjs


function _objectWithoutProperties(source, excluded) {
  if (source == null) return {};
  var target = _objectWithoutPropertiesLoose(source, excluded);
  var key, i;

  if (Object.getOwnPropertySymbols) {
    var sourceSymbolKeys = Object.getOwnPropertySymbols(source);

    for (i = 0; i < sourceSymbolKeys.length; i++) {
      key = sourceSymbolKeys[i];
      if (excluded.indexOf(key) >= 0) continue;
      if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
      target[key] = source[key];
    }
  }

  return target;
}

/***/ })

}]);